import Swiper, { Navigation, Pagination, Thumbs, EffectFade } from 'swiper';

window['ikosSwiper'] = {
    Swiper,
    Navigation,
    Pagination,
    Thumbs,
    EffectFade
}

import "swiper/css";
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
